import chairimg1 from "../assets/chairs/teawook.jpg"
import chairimg2 from "../assets/chairs/burmateakwood.jpg"
import chairimg3 from "../assets/chairs/burmateakwood2.jpg"
import chairimg4 from "../assets/chairs/burmateakwood3.jpg"
import chairimg5 from "../assets/chairs/burmateakwood4.jpg"
import chairimg6 from "../assets/chairs/burmateakwood5.jpg"
import chairimg7 from "../assets/chairs/burmateakwood6.jpg"
import chairimg8 from "../assets/chairs/burmateakwood7.jpg"
import chairimg9 from "../assets/chairs/burmateakwood8.jpg"
import chairimg10 from "../assets/chairs/burmateakwood9.jpg"
import chairimg11 from "../assets/chairs/burmateakwood10.jpg"

import sofa from "../assets/sofa/sofa.jpg"
import sofa2 from "../assets/sofa/sofa2.jpg"
import sofa3 from "../assets/sofa/sofa3.jpg"
import sofa4 from "../assets/sofa/sofa4.jpg"
import sofa5 from "../assets/sofa/sofa5.jpg"
import sofa6 from "../assets/sofa/sofa6.jpg"
import sofa7 from "../assets/sofa/sofa7.jpg"
import sofa8 from "../assets/sofa/sofa8.jpg"
import sofa9 from "../assets/sofa/sofa9.jpg"
import sofa10 from "../assets/sofa/sofa10.jpg"
import sofa11 from "../assets/sofa/sofa11.jpg"

import tv from "../assets/tvcabinet/tv.jpg"
import tv1 from "../assets/tvcabinet/tv2.jpg"
import tv2 from "../assets/tvcabinet/tv3.jpg"

import benche from "../assets/benches/benche.jpg"
import benche1 from "../assets/benches/benche1.jpg"
import benche2 from "../assets/benches/benche2.jpg"
import benche3 from "../assets/benches/benche3.jpg"
import benche4 from "../assets/benches/benche4.jpg"


const FurnData = [
    //chair
    {
        "id": 1,
        "name": "Antique Carved Teak Cane Chair",
        "category": "Chair",
        "primary_material": "Teak Wood",
        "dimensions": {
            "height": "40 inches",
            "width": "25.5 inches",
            "depth": "37.5 inches"
        },
        "delivery_time": "30 days",
        "shipping_charges_and_gst": "extra",
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg1
    },
    {
        "id": 2,
        "name": "Vintage British Colonial Plantation Chair",
        "category": "Chair",
        "primary_material": "Burma Teak Wood",
        "seat_height": "15-16 inches",
        "arm_height": "24 inches",
        "dimensions": {
            "height": "35-44 inches",
            "width": "26-32.5 inches",
            "depth": "45-54 inches"
        },
        "delivery_time": "30 days",
        "shipping_charges_and_gst": "extra",
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg2
    },
    {
        "id": 3,
        "name": "Classic British Colonial Lounge Chair",
        "category": "Chair",
        "primary_material": "Burma Teak Wood",
        "seat_height": "16 inches",
        "dimensions": {
            "height": "36.5-44.5 inches",
            "width": "24-29 inches",
            "depth": "31.5-39.5 inches"
        },
        "delivery_time": "30 days",
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg3
    },
    {
        "id": 4,
        "name": "Modern Teak and Cane Dining Chair",
        "category": "Chair",
        "primary_material": "Burma Teak Wood",
        "seat_height": "14.9 inches",
        "dimensions": {
            "height": "28.6 inches",
            "width": "22.3 inches",
            "depth": "23.9 inches"
        },
        "delivery_time": "30 days",
        "shipping_charges_and_gst": "extra",
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg4
    },
    {
        "id": 5,
        "name": "Chandigarh Style Mid-Century Cane Chair",
        "category": "Chair",
        "primary_material": "Burma Teak Wood",
        "seat_height": "43.5 cm",
        "arm_height": "66.5 cm",
        "dimensions": {
            "height": "77.5 cm",
            "width": "51.0 cm",
            "depth": "60.5 cm"
        },
        "delivery_time": "30 days",
        "shipping_charges_and_gst": "extra",
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg5
    },
    {
        "id": 6,
        "name": "Modern Teak and Rattan Low Chair",
        "category": "Chair",
        "primary_material": "Burma Teak wood, Natural Assam Cane",
        "seat_height": "42 cm",
        "dimensions": {
            "length": "76 cm",
            "breadth": "76 cm",
            "height": "81 cm"
        },
        "delivery_time": "30 days",
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg6
    },
    {
        "id": 7,
        "name": "Sculpted Cane Relaxation Chair",
        "category": "Chair",
        "primary_material": "Burma Teak wood",
        "seat_height": "14.4 inches (36.5 cm)",
        "arm_height": "24.4 inches (62.0 cm)",
        "dimensions": {
            "height": "29.4 inches (74.5 cm)",
            "width": "22.5 inches (57.0 cm)",
            "depth": "30.2 inches (76.5 cm)"
        },
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg7
    },
    {
        "id": 8,
        "name": "Classic British RestoBar Chair",
        "category": "Chair",
        "primary_material": "Burma teak wood, Natural Assam Cane, Mat Finishing",
        "dimensions": {
            "height": "33 inches",
            "width": "22 inches",
            "depth": "25 inches"
        },
        "delivery_time": "30 days",
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg8
    },
    {
        "id": 9,
        "name": "Teakwood Kangaroo Chair",
        "category": "Chair",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "seat_height": "13.5 inches",
        "dimensions": {
            "height": "24 inches",
            "width": "23 inches",
            "depth": "30 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg9
    },
    {
        "id": 10,
        "name": "Folding Beach or Lounge Chair",
        "category": "Chair",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "seat_height": "12 inches",
        "dimensions": {
            "height": "35 inches",
            "width": "24 inches",
            "depth": "31 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg10
    },
    {
        "id": 11,
        "name": "Teakwood Single Rattan Sofa",
        "category": "Chair",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "height": "32 inches",
            "width": "48 inches",
            "depth": "28 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": chairimg11
    },
    //sofa
    {
        "id": 12,
        "name": " British Colonial Teakwood Sofa",
        "category": "Sofa",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "height": "89 cm",
            "width": "203 cm",
            "depth": "68 cm"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa
    },
    {
        "id": 13,
        "name": "Vintage Teakwood Cane Diwan",
        "category": "Sofa",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "height": "33 inches",
            "width": "72 inches",
            "depth": "24 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa2
    },
    {
        "id": 14,
        "name": "Handcrafted Chettinad Diwan",
        "category": "Sofa",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "height": "33 inches",
            "width": "72 inches",
            "depth": "24 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa3
    },
    {
        "id": 15,
        "name": "Handcrafted Teakwood 3 Seater Sofa",
        "category": "Sofa",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "height": "36 inches",
            "width": "72 inches",
            "depth": "24 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa4
    },
    {
        "id": 16,
        "name": "3 Seater Modern Sofa",
        "category": "Sofa",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "seat_height": "16 inches",
        "arm_height": "24 inches",
        "dimensions": {
            "height": "30 inches",
            "width": "72 inches",
            "depth": "30 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa5
    },
    {
        "id": 17,
        "name": "Antique Teakwood Rattan Diwan",
        "category": "Sofa",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "height": "34 inches",
            "width": "76 inches",
            "depth": "24 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa6
    },
    {
        "id": 18,
        "name": "Teakwood 2 seater Rattan Sofa",
        "category": "Sofa",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "height": "32 inches",
            "width": "48 inches",
            "depth": "28 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa7
    },
    {
        "id": 19,
        "name": "Teakwood Modern Sofa",
        "category": "Sofa",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "seat_height": "18 inches",
        "back_height": "35 inches",
        "dimensions": {
            "width": "47 inches",
            "depth": "24 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa8
    },
    {
        "id": 20,
        "name": "Antique 3 seater Rattan Sofa",
        "category": "Sofa",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "seat_height": "18 inches",
        "arm_height": "28 inches",
        "dimensions": {
            "height": "37 inches",
            "width": "79 inches",
            "depth": "29.5 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa9
    },
    {
        "id": 21,
        "name": "Modern 3 seater Sofa",
        "category": "Sofa",
        "primary_material": "Burma Teak Wood",
        "dimensions": "Customized Size",
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa10
    },
    {
        "id": 22,
        "name": "Hand Carved Chettinad 3 Seater Sofa Set",
        "category": "Sofa",
        "primary_material": "Burma Teak Wood",
        "dimensions": "Customized Size",
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": sofa11
    },
    //tv
    {
        "id": 23,
        "name": "Rattan Tv Cabinet",
        "category": "TV",
        "primary_material": "Burma Teak Wood, Natural. Assam cane",
        "delivery_time": "30 days",
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": tv,
        "dimensions": {
            "length": "70 inches",
            "height": "25 inches",
            "depth": "20 inches"
        },
    },
    {
        "id": 24,
        "name": "Modern Tv Cabinet",
        "category": "TV",
        "primary_material": "Burma Teak Wood",
        "delivery_time": "30 days",
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": tv1,
        "dimensions": {
            "length": "60 inches",
            "height": "30 inches",
            "depth": "18 inches"
        },

    },
    {
        "id": 25,
        "name": "Teakwood Rattan Tv cabinet",
        "category": "TV",
        "primary_material": "Burma Teak , Natural Assam cane",
        "dimensions": {
            "length": "69 inches",
            "height": "24 inches",
            "depth": "20 inches"
        },
        "delivery_time": "30 days",
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": tv2,
    },
    //benches
    {
        "id": 26,
        "name": "Curule Bench",
        "category": "Bench",
        "primary_material": "Burma Teak wood & Assam cane",
        "dimensions": {
            "width": "35 inches",
            "height": "17.75 inches",
            "depth": "16 inches"
        },
        "delivery_time": "30 days",
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": benche
    },
    {
        "id": 27,
        "name": "Vintage Long Bench",
        "category": "Bench",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "width": "17.5 inches",
            "height": "16.5 inches",
            "length": "71 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": benche1
    },
    {
        "id": 28,
        "name": "Entryway rattan bench",
        "category": "Bench",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "seat_height": "18 inches",
        "dimensions": {
            "depth": "20 inches",
            "length": "47 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": benche2
    },
    {
        "id": 29,
        "name": "Teakwood Cane bench",
        "category": "Bench",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "depth": "18 inches",
            "length": "54 inches",
            "height": "16 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": benche3
    },
    {
        "id": 30,
        "name": "Teak and Rattan Bench",
        "category": "Bench",
        "primary_material": "Burma Teak wood, Natural Assam cane",
        "dimensions": {
            "depth": "18 inches",
            "length": "54.5 inches",
            "height": "14 inches"
        },
        "delivery_time": "30 days",
        "customizable": true,
        "finishes": ["standard", "premium", "custom"],
        "description": "Available in Custom sizes in all standard, premium, and custom finishes",
        "image": benche4
    }
]

export default FurnData;